module.exports = __webpack_public_path__ + "img/clermont.b2bdc1bd.png";